import Dashboard from "screens/private/readers-tags/dashboard";
export default Dashboard;
